import api from './api';

export const notificacionesService = {
    listar: async (soloNoLeidas = false, limit = 20) => {
        const response = await api.get('/notifications/', {
            params: { solo_no_leidas: soloNoLeidas, limit },
        });
        return response.data;
    },

    contador: async () => {
        const response = await api.get('/notifications/contador');
        return response.data.no_leidas;
    },

    marcarLeida: async (id) => {
        const response = await api.post(`/notifications/${id}/leer`);
        return response.data;
    },

    marcarTodasLeidas: async () => {
        const response = await api.post('/notifications/leer-todas');
        return response.data;
    },
};
